<template>
  <div class="news_list">
    <BlogListHeader
      :content="content"
      :unic_id="_.get(this.contentData, 'conf.unicId')"
      :format_calendar="format_calendar"
      :title="_.get(this.contentData, 'conf.header.title')"
    />
    <div class="news_list__inner container bg_white">
      <div class="news_list__calendar">
        <div
          class="news_list__calendar--title flex a_center wc-lg pointer"
          :style="{ opacity: value1 ? 0 : 1 }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19.578"
            height="19.166"
            viewBox="0 0 19.578 19.166"
          >
            <path
              id="date"
              d="M19.584,5.066H17.874V4.448a.959.959,0,0,0-.948-.948h-.68a.959.959,0,0,0-.948.948v.618H9.26V4.448A.959.959,0,0,0,8.312,3.5h-.68a.959.959,0,0,0-.948.948v.618H4.994A2.489,2.489,0,0,0,2.5,7.56V20.172a2.489,2.489,0,0,0,2.494,2.494h9.665a4.4,4.4,0,0,0,3.132-1.3l2.988-2.988h0a4.4,4.4,0,0,0,1.3-3.132V7.56A2.5,2.5,0,0,0,19.584,5.066ZM4.046,20.172V10.095H20.532v5.028H16.555a2.023,2.023,0,0,0-2.02,2.02V21.12H4.994A.959.959,0,0,1,4.046,20.172Zm12.654.1a2.653,2.653,0,0,1-.618.453V17.143a.466.466,0,0,1,.474-.474h3.586a2.654,2.654,0,0,1-.453.618Z"
              transform="translate(-2.5 -3.5)"
              fill="#7063e9"
            />
          </svg>
          <span
            class="f-16 medium"
            v-if="
              date_picked.start == 'Invalid date' ||
                date_picked.start == '' ||
                date_picked == ''
            "
            >{{ $fn.tr("აირჩიე თარიღი") }}</span
          >
        </div>
        <el-date-picker
          v-model="value1"
          type="daterange"
          :append-to-body="false"
          :start-placeholder="$fn.tr('Start Date')"
          :end-placeholder="$fn.tr('End Date')"
          :unlink-panels="true"
          @focus="enable_btn"
          :class="{ picked: value1 }"
          :clear-icon="'calendar-x'"
          class="news_list__calendar--inner"
          :value-format="'yyyy-MM-dd'"
        >
        </el-date-picker>
      </div>
      <div class="news_list__inner--grid grid">
        <router-link
          :to="$store.getters['main/getSingleUrl'](story)"
          :key="index"
          v-for="(story, index) in $store.state.main.news_content"
          class="news_list__box br-12 flex column bg-gray"
        >
          <div class="news_list__img_wrapper">
            <img
              :src="story.slider_image[0].url"
              class="cover"
              :alt="
                $route.name == 'PageViewRouter_ge' && story.seo_keywords_ge
                  ? story.seo_keywords_ge
                  : $route.name == 'PageViewRouter_en' && story.seo_keywords_en
                  ? story.seo_keywords_en
                  : ''
              "
            />
          </div>

          <div class="news_list__text-box flex column wc-lg">
            <h2 class="f-18 bold uppercase">{{ story.title }}</h2>
            <h3 class="f-14 medium">{{ story.teaser }}</h3>
          </div>
        </router-link>
      </div>
      <div
        class="news_list__load_more flex j_center a_center"
        v-if="news_content.length < $store.state.main.news_listCount"
      >
        <div
          class="news_list__load_more--btn button pointer bg-light-purple wc-lg"
          @click="load_more($store.state.main.news_search_keywords)"
        >
          <span class="f-14 bold uppercase f-white">{{
            $fn.tr("მეტის ჩვენება")
          }}</span>
        </div>
      </div>
      <div
        class="search__results_wrapper flex j_center wc-lg"
        v-if="news_content.length == 0"
      >
        <span class="f-55 bold">{{ $fn.tr("შედეგი არ მოიძებნა") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
import BlogListHeader from "@/components/modules/BlogListHeader";
import fn from "@/helpers/func";
export default {
  props: ["contentData"],
  mixins: [resize_handler],
  components: {
    BlogListHeader
  },
  data() {
    return {
      value1: "",
      date_picked: "",
      active_calendar: false
    };
  },
  computed: {
    page_count() {
      this.$store.state.main.news_page_count = _.get(
        this.contentData,
        "conf.page_count"
      );
      return _.get(this.contentData, "conf.page_count");
    },
    uniq_id() {
      return _.get(this.contentData, "conf.unicId");
    },
    format_calendar() {
      if (this.value1) {
        this.date_picked = {
          end: this.value1[1],
          start: this.value1[0]
        };
        return this.date_picked;
      } else {
        return (this.date_picked = "");
      }
    },
    news_content() {
      return this.$store.state.main.news_content;
    },
    content() {
      return _.get(this.contentData, "data.list");
    }
  },
  created() {
    this.$store.state.main.news_content = _.get(this.contentData, "data.list");
    this.$store.state.main.news_listCount = _.get(
      this.contentData,
      "data.listCount"
    );
  },
  mounted() {},

  methods: {
    enable_btn() {
      this.active_calendar = true;
      let disabled = this.$el.querySelectorAll(".news_list .is-disabled");
      if (!disabled) return false;
      disabled.forEach(item => {
        item.disabled = false;
        item.classList.remove("is-disabled");
      });
    },
    async load_more(key_words) {
      this.$store.state.main.current_page =
        this.$store.state.main.current_page + 1;

      let params = {
        id: _.get(this.$store.state.main.selected_menu, "id"),
        componentUnicId: this.uniq_id,
        searchText: key_words,
        searchTerms: this.$store.state.main.news_filter_values,
        searchDate: [this.format_calendar.start, this.format_calendar.end],
        pageNumber: this.$store.state.main.current_page,
        perPage: parseInt(this.page_count)
      };

      let res = await fn.postData("main/getDataList", params);
      this.$store.state.main.news_content = this.$store.state.main.news_content.concat(
        res.data.list
      );
      this.$store.state.main.trigger_update = !this.$store.state.main
        .trigger_update;

      this.$store.state.main.news_listCount = res.data.listCount;

      if (
        this.$store.state.main.news_content.length ==
        _.get(res, "data.listCount")
      ) {
      } else {
      }
    }
  },
  watch: {
    date_picked() {
      this.$store.commit("main/setState", {
        key: "trigger_update",
        val: !this.$store.state.main.trigger_update
      });
    }
  }
};
</script>

<style lang="sass">

.el-date-table td.today span, .el-picker-panel__icon-btn:hover
  color: #7063E9
.el-date-table td.end-date span, .el-date-table td.start-date span
  background-color: #7063E9
.el-date-table td.available:hover
  color: #7063E9
.el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner
  width: 220px
.el-date-range-picker
  width: 360px !important
  left: 0
  @media (max-width: 390px)
    width: 285px !important
  &__content
    width: 100%
    @media (max-width: 390px)
      padding: 10px
    &.is-right
      display: none
  .el-picker-panel__body
    min-width: 360px !important
    @media (max-width: 390px)
      min-width: 285px !important

.el-range-editor
  background-color: transparent
  &.is-active, &.is-active:hover
    border-color: transparent
  .el-range__icon
    display: none
  .el-range-input, .el-range-separator
    opacity: 0
  &.el-input__inner
    padding-left: 0
    padding-right: 0
    border: none
  .el-range__close-icon
    &:after
      background: url('../../assets/imgs/x_btn.svg')
      width: 12px
      height: 12px
      opacity: 0
  &.picked
    .el-range__close-icon
      &:after
        opacity: 1
    .el-range-separator
      opacity: 1
      transition: .4s
    .el-range-input
      opacity: 1
      transition: .4s
.el-date-table th
  @media (max-width: 390px)
    font-size: 12px
</style>
